<script>
import Overlay from '@/assets/js/src/components/Overlay.vue'
import { slugify, } from '@/assets/js/src/util/slugify'
import read from '@/assets/js/src/modules/navigation/_components/data/read.json'
import { debounce, } from '@/assets/js/src/util/uiTools'
import ButtonListGrid from '@/assets/js/src/components/ButtonListGrid.vue'
import { mapState, mapWritableState, } from 'pinia'
import { useBibleStore, } from '@/assets/js/src/modules/bible/_pinia/bible'
import LoadingDummyP from '@/assets/js/src/components/loading/LoadingDummyP'
import LoadingDummyCustom from '@/assets/js/src/components/loading/LoadingDummyCustom'
import { useHelpListApi, } from '@/assets/js/src/modules/help/_composables/useHelpListApi'
import { useUserOptions, } from '@/assets/js/src/modules/user/_composables/useUserOptions'
import { useHelpStore, } from '@/assets/js/src/modules/help/_pinia/help'
import { useBibleRefs, } from '@/assets/js/src/util/composables/useBibleRefs'
import { useAppUiStore, } from '@/assets/js/src/pinia/appUi'
import H1Title from '@/assets/js/src/components/overlay/H1Title.vue'
import ResourceAbbrivationFilter from '@/assets/js/src/components/forms/ResourceAbbrivationFilter.vue'
import SearchFilter from '@/assets/js/src/components/forms/SearchFilter.vue'
import { useListHeadInfo, } from '@/assets/js/src/modules/help/_composables/useListHeadInfo'
import { useTranslation, } from '@/assets/js/src/util/composables'

export default {
    name: 'Help',
    components: {
        SearchFilter,
        ResourceAbbrivationFilter,
        H1Title,
        LoadingDummyCustom,
        LoadingDummyP,
        Overlay,
        ButtonListGrid,
    },
    setup () {
        return {
            ...useHelpListApi(),
            ...useUserOptions(),
            ...useBibleRefs(),
            ...useListHeadInfo(),
            ...useTranslation(),
        }
    },
    data: () => ({
        filter: [],
        search: '',
        debouncedSearch: '',
    }),
    computed: {
        ...mapState(useBibleStore,[
            'selectedBibles',
        ]),
        ...mapWritableState(useHelpStore,[
            'backToList',
        ]),
        ...mapWritableState(useAppUiStore,[
            'startHelpTour',
        ]),
        categories: function () {
            let categories = []
            this.helpCategories.forEach((elem) => {
                categories.push(elem.name)
            })

            return categories
        },
        items: function () {
            if (this.filter.length === 0 && this.debouncedSearch.trim() === '') {
                return this.helpItems
            }
            let helpItems = globalThis.clone(this.helpItems)

            let items = helpItems.filter((elem) => {
                if (typeof elem.categories === 'undefined') {
                    return false
                } else {
                    for (let i = 0; i < elem.categories.length; i++) {
                        if (this.filter.includes(elem.categories[i].name)) {
                            return true
                        }
                    }

                    return false
                }
            })

            if (this.debouncedSearch.trim() !== '') {
                items = this.helpItems.filter((elem) => {
                    if (elem.title.toLowerCase().indexOf(this.debouncedSearch.toLowerCase()) !== -1) {
                        return true
                    } else {
                        return elem.message.toLowerCase().indexOf(this.debouncedSearch.toLowerCase()) !== -1
                    }
                })
            }

            return items
        },
        composedItems: function () {
            return this.items.map((item)=>{
                return {
                    ...item,
                    slug: slugify(item.title),
                    stripedMessage: item.message
                        .replace(/\$\$(.[^$]*)\$\$/g, ' ')
                        .replace(/<[^>]*>/g, ' '),
                }
            })
        },
    },
    watch: {
        search: {
            handler: debounce(function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.debouncedSearch = newValue
                }
            }, 300),
            immediate: !import.meta.env.SSR,
        },
    },
    methods: {
        handleLink (event) {
            event.preventDefault()
            this.backToList = true
        },
        startTour (type) {
            let path
            let biblePart = this.selectedBibles.join('.')
            if (type === 'text') {
                let rand = Math.floor(Math.random() * 99)
                let chapterCanonical = parseInt(Math.floor(parseInt(read[rand][0]) / 1000) * 1000)
                path = '/' + encodeURIComponent(biblePart) + '/' + this.getRefByCanonicals({
                    canonicals: [ chapterCanonical, ],
                    isUrl: true,
                })
            } else {
                path = encodeURI('/search/' + biblePart + '/' + this.t('async.help.search_example'))
            }

            this.startHelpTour = true
            this.$router.push({ path, })
        },
    },
}
</script>

<template>
    <overlay
        class-name="help-list"
        full-width
    >
        <v-row
            no-gutters
        >
            <v-col
                cols="12"
                md="6"
                offset-md="3"
            >
                <div class="d-flex">
                    <h1-title title-key="async.help.heading" />

                    <v-spacer></v-spacer>
                    <!-- ICONS LIST/GRID VIEW -->
                    <button-list-grid
                        :grid-view="gridView"
                        @toggle="gridView = !gridView"
                    ></button-list-grid>
                </div>
                <p v-if="messagesLoaded">
                    {{ description }}
                </p>
                <loading-dummy-p
                    v-else
                ></loading-dummy-p>

                <div class="help-list__buttons">
                    <template v-if="messagesLoaded">
                        <v-btn
                            color="primary"
                            :title="t('async.help.tour.button.text')"
                            @click="startTour('text')"
                            @keypress="startTour('text')"
                        >
                            {{ t('async.help.tour.button.text') }}
                        </v-btn>
                        <v-btn
                            color="primary"
                            :title="t('async.help.tour.button.search')"
                            @click="startTour('search')"
                            @keypress="startTour('search')"
                        >
                            {{ t('async.help.tour.button.search') }}
                        </v-btn>
                    </template>
                    <template v-else>
                        <div class="d-flex">
                            <loading-dummy-custom
                                height="36px"
                                width="300px"
                                margin="8px"
                            ></loading-dummy-custom>
                            <loading-dummy-custom
                                height="36px"
                                width="300px"
                                margin="8px"
                            ></loading-dummy-custom>
                        </div>
                    </template>
                </div>

                <resource-abbrivation-filter
                    v-model="filter"
                    :items="categories"
                    label-key="async.help.filter"
                />

                <search-filter
                    v-model="search"
                    label-key="async.help.search_filter"
                />
            </v-col>
        </v-row>
        <transition-group
            v-if="asyncStatusLoaded"
            name="scale-trans"
            tag="div"
            :class="[`v-row v-row__no-gutters help-list__${gridView?'grid':'list'}`,'d-flex']"
        >
            <v-col
                v-for="(item,index) in composedItems"
                :key="item.id"
                :cols="gridView?6:12"
                :lg="gridView?2:undefined"
                :md="gridView?3:6"
                :offset-md="!gridView?3:undefined"
                :sm="gridView?4:undefined"
                :class="`help-list__${gridView?'grid':'list'}__wrapper`"
            >
                <router-link
                    :title="item.title"
                    :to="{path:'/help/' + item.slug + '/' + item.id}"
                    :class="[{'first': index === 0,'elevation-1':gridView}, `help-list__${gridView?'grid':'list'}__wrapper__item`,]"
                    @click="handleLink"
                >
                    <h2>{{ item.title }}</h2>
                    <p>{{ item.stripedMessage }}</p>
                </router-link>
            </v-col>
        </transition-group>
        <div
            v-else
            :class="[`help-list__${gridView?'grid':'list'}`,'d-flex']"
        >
            <v-col
                v-for="n in 12"
                :key="'dummy_' + n"
                :cols="gridView?6:12"
                :lg="gridView?2:undefined"
                :md="gridView?3:6"
                :offset-md="!gridView?3:undefined"
                :sm="gridView?4:undefined"
                :class="`help-list__${gridView?'grid':'list'}__loading-dummy`"
            >
                <loading-dummy-custom
                    :height="gridView?'146px':'82px'"
                    :width="gridView?'calc(100% - 8px)':'100%'"
                    :margin="gridView?'8px':'16px 0px 16px 0px'"
                ></loading-dummy-custom>
            </v-col>
        </div>
    </overlay>
</template>

<style lang="scss">
.bs-app .help-list {
    .list-enter-active, .list-leave-active {
        transition: all 1s;
    }

    .list-enter-from, .list-leave-to {
        max-width: 0;
        margin: 0;
        padding: 0;
        opacity: 0;
    }

    .scale-trans {
        &-enter-from, &-leave-to {
            transform: scale(0);
            opacity: 0;
        }

        &-move {
            transition: transform .3s;
        }

        &-leave-active {
            position: absolute;
        }
    }

    &__buttons {
        margin: 0 0 #{map-deep-get($bs-xl, overlay,elements,marginBottom)} -8px;

        @media (max-width: #{map-deep-get($bs-xs, breakpointValue)}px) {
            margin-bottom: 0;
        }
    }

    &__grid {
        margin: 0 -#{map-deep-get($bs-xl, overlay, grid, margin)};
        padding: 0 map-deep-get($bs-xl, body, paddingX);

        @media (max-width: #{map-deep-get($bs-xs, breakpointValue)}px) {
            padding: 0;
        }

        &__wrapper {
            &__item {
                display: block;
                padding: 20px 10px;
                text-decoration: none;
                background: var(--bs-color-white);

                h2 {
                    margin: 0 0 8px;
                    padding: 0;
                    overflow: hidden;
                    color: map-deep-get($bs-color, bsHighlight);
                    font-weight: 400;
                    font-size: 20px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    transition: transform .1s ease-in;
                }

                p {
                    max-height: 60px;
                    margin: 0 -.5em 0 0;
                    padding: 0 .5em 0 0;
                    overflow: hidden;
                    color: var(--bs-color-black);
                    font-size: 14px;
                    line-height: 20px;
                    hyphens: auto;
                }

                &:hover, &:focus {
                    h2 {
                        font-weight: bold;
                    }
                }
            }
        }
    }

    &__list {
        &__wrapper {
            padding-top: 0;
            padding-bottom: 0;

            &__item {
                display: block;
                padding: 20px 16px 16px;
                text-decoration: none;
                cursor: pointer;

                &:not(.first) {
                    border-top: 1px solid var(--bs-color-grey);
                }

                h2 {
                    margin: 0 0 8px;
                    padding: 0;
                    overflow: hidden;
                    color: map-deep-get($bs-color, bsHighlight);
                    font-weight: 400;
                    font-size: 20px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    transition: transform .1s ease-in;
                }

                p {
                    max-height: 60px;
                    margin: 0 -.5em 0 0;
                    padding: 0 .5em 0 0;
                    overflow: hidden;
                    color: var(--bs-color-black);
                    font-size: 14px;
                    line-height: 20px;
                    hyphens: auto;
                }

                &:hover, &:focus {
                    background-color: var(--bs-color-white);

                    h2 {
                        font-weight: 700;
                    }
                }
            }
        }

        &__loading-dummy {
            border-top: 1px solid map-deep-get($bs-color, grey);

            @include dark {
                border-top: 1px solid map-deep-get($bs-color, invert, greyDark);
            }
        }
    }
}
</style>
